import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'citydeals-auth-client-login-modal',
  templateUrl: './auth-client-login-modal.component.html',
  styleUrls: ['./auth-client-login-modal.component.scss'],
})
export class AuthClientLoginModalComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
